import React, { useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";

const AnimatedTextCard = ({ imageSrc, title, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      sx={{
        width: "400px",
        height: "300px",
        background: "#000",
        color: "#fff",
        padding: "20px",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // Ensures even spacing
        alignItems: "flex-start", // Align content to the left
        textAlign: "left",
        cursor: "pointer",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Icon/Image at the Top Left */}
      <Box
        component="img"
        src={imageSrc}
        sx={{
          width: "50px",
          height: "50px",
          textWrap:"wrap",
        }}
        alt="icon"
      />

      {/* Animated Title */}
      <motion.div
        initial={{ y: 0 }}
        animate={{ y: isHovered ? "-10px" : "0px" }}
        transition={{ duration: 0.4 }}
      >
        <Typography variant="h5" style ={{width:"90%"}} sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      </motion.div>

      {/* Description at the Bottom */}
      <Typography variant="body1" style ={{width:"80%"}}>{description}</Typography>
    </Box>
  );
};

export default AnimatedTextCard;
